// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2426":"d05ff449","2792":"02b2f69c"}[chunkId] + ".chunk.css";
};